import LoadSearchTemplateDialogLayout from './loadSearchTemplateDialog/LoadSearchTemplateDialogLayout';
import type { LoadSearchTemplateDialogProps } from './loadSearchTemplateDialog/types';
import { useLoadSearchTemplateDialog } from './loadSearchTemplateDialog/useLoadSearchTemplateDialog';

export { debugAtom } from './loadSearchTemplateDialog/stateAtoms';
export type {
  ElectionElectorates,
  MapNodeIdToElectionElectorates,
} from './loadSearchTemplateDialog/types';

export default function LoadSearchTemplateDialog(props: LoadSearchTemplateDialogProps) {
  const dialog = useLoadSearchTemplateDialog(props);

  return <LoadSearchTemplateDialogLayout dialog={dialog} />;
}
